import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { OAuthApplication } from "../../auth";

export async function SearchCPF(cpf: string, authType?: string) {
  const url = `${endpoints.SIGNUP}/1.0.0/searchCPF`;

  const bearerToken =
    authType === "application"
      ? await OAuthApplication()
      : await useAuth.getUserToken();

  const headers = {
    Accept: "*/*",
    Authorization: bearerToken ?? "",
    "Content-Type": "application/json",
  };

  // Implementando timeout de 20s com AbortController
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 20000);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify({ cpf }),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    // Tratamento específico para status 422 (UnprocessableEntity)
    if (response.status === HTTPResponseStatus.UnprocessableEntity) {
      return {
        status: HTTPResponseStatus.UnprocessableEntity,
        data: {},
      };
    }
    // Tratamento específico para status 451 (ClientError) - Lei Felca (Menor de idade)
    if (response.status === HTTPResponseStatus.ClientError) {
      return {
        status: HTTPResponseStatus.ClientError,
        data: {},
      };
    }

    if (!response.ok) {
      throw new Error(`SearchCPF: ${response.status}`);
    }

    const data = await response.json();
    return { status: HTTPResponseStatus.Success, data };
  } catch (error) {
    console.log("error", error);
    return {
      status: HTTPResponseStatus.BadRequest,
      data: `${error}`,
    };
  }
}
